import { app } from '../app';


export class LoginCallbackController {

    static $inject = [];

    constructor() {

        // Note,
        // when visiting this page it is via login,
        // the authResult contains a state which the authService uses to redirect,
        // so all we need to do is display a blank page.
    }
}

app.controller('LoginCallbackController', LoginCallbackController);
